export default __webpack_public_path__ + "static/media/big_head_-7.d2ee4a89.webp";